import React, { Component } from 'react'
import { Spin, Button, Form, Layout, Icon, Switch, PageHeader, Input, Select, Upload, message, Calendar, Modal, InputNumber } from 'antd'
import Editor from 'wangeditor'
import moment from 'moment'

import PrevImg from '_src/components/PrevImg/PrevImg'
import { UploadIMGToOss } from '_src/utils/base'
import {createTravel, travelDetail, saveTravelMoney} from '_src/api/api'
import './style.less'

const { Option } = Select

const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">上传</div>
  </div>
)

@Form.create({name: ''})
class CreateTravel extends Component {
  constructor (props) {
    super(props)
    // 3个月区间
    let newDate = new Date()
    newDate.setMonth((newDate.getMonth()) + 3)
    this.state = {
      isLoading: true,
      fileList: [],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment(newDate).format('YYYY-MM-DD'),
      travelDates: [],
      date_all: []
    }
  }

  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')
    // 带id进来是编辑
    if (id) {
      travelDetail({id})
        .then(res => {
          const fileList = []
          JSON.parse(res.data.gallery).forEach((item, index) => {
            fileList.push({ uid: index, name: 'xxx.png', status: 'done', url: item})
          })
          const now = moment().format('YYYY-MM-DD')
          res.data.dates = res.data.dates.filter(item =>item.date >= now)
          this.setState({
            id,
            info: res.data,
            fileList,
            isLoading: false,
            travelDates: res.data.dates,
            title: '修改旅游专线'
          })
          this.initEditor(res.data.detail)
        })

    // 否则是新建
    } else {
      this.setState({isLoading: false,title: '新增旅游专线'})
      // 初始化富文本
      this.initEditor()
      this.getYearAndMonthAndDay()
    }
  }

  // 初始化富文本
  initEditor (detail) {
    this.editor = new Editor('#editor')
    this.editor.customConfig.zIndex = 10
    this.editor.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'italic', // 斜体
      'list', // 列表
      'justify', // 对齐方式
      'image', // 插入图片
      'table', // 表格
      'undo', // 撤销
      'redo' // 重复
    ]
    this.editor.customConfig.customUploadImg = function (files, insert) {
      files.forEach(item => {
        var reader = new FileReader()
        reader.onload = function (e) {
          item.thumbUrl = reader.result
          UploadIMGToOss(item)
            .then(res => {
              insert(res)
            })
        }
        reader.readAsDataURL(item)
      })
    }
    this.editor.create(detail)
    this.editor.txt.html(detail)
  }

  // 遍历3个月日期 年-月-日
  getYearAndMonthAndDay = () => {
    const { startDate, endDate, date_all} = this.state
    let i = 0
    let startTime = this.getDate(startDate)
    let endTime = this.getDate(endDate)
    while ((endTime.getTime()-startTime.getTime())>=0) {
        let year = startTime.getFullYear()
        let month = (startTime.getMonth()+1).toString().length === 1 ? '0'+ (startTime.getMonth()+1).toString():(startTime.getMonth()+1).toString()
        let day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate():startTime.getDate()
        date_all[i] = year + '-' + month + '-' + day
        startTime.setDate(startTime.getDate()+1)
        i += 1
    }
  }

  getDate = (date) => {
    let temp = date.split('-')
    return new Date(temp[0],temp[1]-1,temp[2])
  }

  // 设置初始统一值
  setInitialPrice = (tickets, salePrice, costPrice) => {
    const { date_all, travelDates} = this.state
    salePrice = salePrice* 100
    costPrice = costPrice* 100
    date_all.forEach(item => {
        travelDates.push({date: item, tickets: tickets, salePrice: salePrice, costPrice: costPrice})
    })
  }

  // 日历时间可选判断
  disabledDate = (item) => {
    const {startDate, endDate} = this.state
    item = moment(item).format('YYYY-MM-DD')
    return item < startDate || item > endDate
  }
  // 日历单元格渲染
  dateCellRender = (item) => {
    const {startDate, endDate, travelDates} = this.state
    item = moment(item).format('YYYY-MM-DD')
    // 不可设置内容区域
    if (item < startDate || item > endDate) {
      return <div className='data-after-content flex-a'>/</div>
    } 
    // 判断已设置价格
    const curObj = travelDates.filter(ele => ele.date === item)[0]
    if (curObj) {
      return (
        <div className='data-after-content'>
          <div><span style={{fontSize: 12}}>票数：</span>{curObj.tickets}张</div>
          <div className='price'><span style={{fontSize: 12}}>售价：</span>{(curObj.salePrice / 100).toFixed(2)}</div>
          <div className='price-default'><span style={{fontSize: 12}}>原价：</span>{(curObj.costPrice / 100).toFixed(2)}</div>
        </div>
      )
    }
    return <div className='data-after-content not-content flex-a'>点击设置价格</div>
  }
  // 日历单元格点击回调
  onDateSelect = (selectDate) => {
    selectDate = moment(selectDate).format('YYYY-MM-DD')
    const {travelDates} = this.state
    const selectInfo = travelDates.length ? travelDates.filter(item => item.date === selectDate)[0] : ''
    this.setState({
      visible: true,
      selectDate,
      selectInfo,
    })
  }
  // 关闭
  cancelMoneyModal = () => this.setState({visible: false})
  // 回调设置金额
  onSetMoney = (obj) => {
    // 价格存储单位分
    obj.salePrice = obj.salePrice * 100
    obj.costPrice = obj.costPrice * 100
    let {travelDates, selectDate, id, date_all} = this.state
    if (date_all.indexOf(selectDate) > -1) {
        date_all = date_all.filter(n => n !== selectDate)
        this.setState({
            date_all: date_all
        })
    }
    if (id) {
        this.saveEditMoney(id, obj, selectDate)
    }
    if (travelDates.length) {
      let have = false
      travelDates.forEach(item => {
        if (item.date === selectDate) {
          have = true
          item.salePrice = obj.salePrice
          item.costPrice = obj.costPrice
          item.tickets = obj.tickets
        }
      })
      if (!have) {
        obj.date = selectDate
        travelDates.push(obj)
      }
    } else {
      obj.date = selectDate
      travelDates.push(obj)
    }
    this.cancelMoneyModal()
    this.setState({travelDates})
  }

  // 保存修改单条金额设置
  saveEditMoney = (id, obj, selectDate) => {
      obj.date = selectDate
      this.setState({isLoading: true})
      saveTravelMoney(id, [obj])
      .then(res => {
       this.setState({isLoading: false})
        message.success('编辑成功!', 1.2, () => {
            })
        })
  }

  // 图片预览 
  handlePreview = (file) => this.PrevImg.show(file.thumbUrl)
  // 选择图片回调
  handleChange = ({ fileList }) => this.setState({ fileList })
  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    const _this = this
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const {fileList, travelDates, id} = this.state
        if (!id) {
            this.setInitialPrice(values.tickets, values.salePrice, values.costPrice)
        }
        values.travelType = Number(values.travelType)
        values.status = values.status ? 0 : 1
        values.detail = this.editor.txt.html()
        values.travelDates = travelDates
        const prmsArr = []
        fileList.forEach((item, index) => {
          prmsArr[index] = new Promise((resolve, reject) => {
            if (item.url) {
              resolve(item.url)
            } else {
              UploadIMGToOss(item)
                .then(data => {
                  if (data) {
                    resolve(data)
                  } else {
                    message.error('图片上传失败！', 1.5)
                  }
                })
                .catch(function (err) {
                  message.error('图片上传失败！', 1.5)
                  reject(err)
                  return false
                })
            }
          })
        })
        Promise.all(prmsArr)
          .then(gallery => {
            values.gallery = gallery
            const {id} = _this.state
            _this.setState({isLoading: true})
            createTravel(values, id)
              .then(res => {
                _this.setState({isLoading: false}) 
                message.success('编辑成功!', 1.2, () => {
                  _this.props.history.replace('/trip/travelDetail?id=' + res.data.id)
                })
              })
          })
      } else {
        document.querySelector('#main').scrollTop = 0
      }
    })
  }
  render () {
    const {
      info,
      selectInfo,
      isLoading,
      fileList,
      visible,
      selectDate
    } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <Layout className="createTravel-page" style={{ padding: 20, paddingTop: 40, backgroundColor: 'white' }}>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='flex-h-a' title={this.state.title} style={{borderLeft: '5px solid #1890ff', height: 30}} />
        <div className="" style={{paddingTop: 20}}>
          <Form onSubmit={this.handleSubmit} style={{paddingLeft: 30}}>
            <PageHeader title={<span><Icon type="profile" /> 基本信息</span>} style={{paddingLeft: 0}} />
            <Form.Item label="旅游专线名称：" className='flex'>
              {getFieldDecorator('travelName', {
                rules: [{
                  required: true,
                  message: '请输入旅游专线名称',
                }],
                initialValue: info && info.travelName ? info.travelName : '',
              })(
                <Input placeholder="旅游专线名称" style={{width: 400}} />
              )}
            </Form.Item>
            <Form.Item label="线路类型：" className='flex'>
              {getFieldDecorator('travelType', {
                rules: [{
                  required: true,
                  message: '请选择线路类型',
                }],
                initialValue: info && info.travelType ? info.travelType : '',
              })(
                <Select
                  style={{width: 400}}
                  placeholder="选择线路类型"
                  onChange={this.handleSelectChange}
                >
                  <Option value={1}>省内游</Option>
                  <Option value={2}>国内游</Option>
                  <Option value={3}>出境短游</Option>
                  <Option value={4}>出境长游</Option>
                </Select>
              )}
            </Form.Item>
            <Form.Item label="合作方" className='flex'>
              {getFieldDecorator('partner', {
                rules: [{
                  required: true,
                  message: '请输入合作方',
                }],
                initialValue: info && info.partner ? info.partner : '',
              })(
                <Input placeholder="合作方" style={{width: 400}} />
              )}
            </Form.Item>
            <Form.Item label="状态" className='flex'>
              {getFieldDecorator('status', {
                initialValue: info ? info.status === 0 : false,
                valuePropName: 'checked'
              })(
                <Switch checkedChildren="上架" unCheckedChildren="下架" />
              )}
            </Form.Item>
            <Form.Item label="商品图片：" className='flex'>
              {getFieldDecorator('gallery', {
                rules: [{
                  required: true,
                  message: '请上传商品图片',
                }],
                initialValue: info ? info.gallery : '',
              })(
                <Upload
                  className='upload-img flex-j-a'
                  action=""
                  multiple
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={this.handlePreview}
                  onChange={this.handleChange}
                  beforeUpload = {()=>{ return false }}
                >
                  {fileList && fileList.length >= 5 ? null : uploadButton}
                </Upload>
              )}
            </Form.Item>
            { this.state.id
              ? '': (<div>
                <Form.Item label="票数：" className='flex'>
                    {getFieldDecorator('tickets', {
                    rules: [{
                        required: true,
                        message: '请输入出售票数',
                    }],
                    initialValue: info && info.tickets ? info.tickets : '',
                    })(
                    <InputNumber placeholder="请输入出售票数" style={{width: 250}} />
                    )}
                </Form.Item>
                <Form.Item label="出售价：" className='flex'>
                    {getFieldDecorator('salePrice', {
                    rules: [{
                        required: true,
                        message: '请输入出售价格',
                    }],
                    initialValue: info && info.salePrice ? (info.salePrice / 100).toFixed(2) : '',
                    })(
                    <InputNumber placeholder="请输入出售价" style={{width: 250}} />
                    )}
                </Form.Item>
                <Form.Item label="原价：" className='flex'>
                    {getFieldDecorator('costPrice', {
                    rules: [{
                        required: true,
                        message: '请输入原价',
                    }],
                    initialValue: info && info.costPrice ? (info.costPrice / 100).toFixed(2) : '',
                    })(
                    <InputNumber placeholder="请输入原价" style={{width: 250}} />
                    )}
                </Form.Item>         
            </div>)}
            <div style={{marginTop: 50}}>
              <PageHeader title={<span><Icon type="profile" /> 出游日期 （设置每天的价格，售票范围3个月之内）</span>} style={{paddingLeft: 0, marginBottom: 20}} />
              <div className='Calendar-inner'>
                <Calendar 
                  onSelect={this.onDateSelect} 
                  disabledDate={this.disabledDate}
                  dateCellRender={this.dateCellRender}
                />
              </div>
            </div>
            <div style={{marginTop: 50}}>
              <PageHeader title={<span><Icon type="profile" /> 商品描述</span>} style={{paddingLeft: 0, marginBottom: 20}} />
              <div id="editor" className='editor-inner'>
                <p>商品描述...</p>
              </div>
            </div>
            <Form.Item>
              <Button type="primary" htmlType="submit" size='large' style={{width: 180, marginLeft: 90, marginTop: 40}}>保存</Button>
            </Form.Item>
          </Form>
        </div>
        <SetMoney {...{visible, selectInfo, selectDate }} onCancel={this.cancelMoneyModal} onSetMoney={this.onSetMoney} />
      </Layout>
    )
  }
}

export default CreateTravel

// 设置出售价和原价的组件
@Form.create({name: ''})
class SetMoney extends Component {
  
  // 设置价格提交,
  setMoney = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSetMoney(values)
      }
    })
    return
  }

  render () {
    const {selectInfo, visible, onCancel, selectDate} = this.props
    const { getFieldDecorator } = this.props.form
    return (
      <Modal
        title={`设置专线价格（${moment(selectDate).format('YYYY年MM月DD日')}）`}
        visible={visible}
        onCancel={onCancel}
        width={500}
        footer={false}
        destroyOnClose
      >
        <Form onSubmit={this.setMoney} className="discount-form">
          <Form.Item label="票数：" className='flex'>
            {getFieldDecorator('tickets', {
              rules: [{
                required: true,
                message: '请输入出售票数',
              }],
              initialValue: selectInfo && selectInfo.tickets ? selectInfo.tickets : '',
            })(
              <InputNumber placeholder="请输入出售票数" style={{width: 250}} />
            )}
          </Form.Item>
          <Form.Item label="出售价：" className='flex'>
            {getFieldDecorator('salePrice', {
              rules: [{
                required: true,
                message: '请输入出售价格',
              }],
              initialValue: selectInfo && selectInfo.salePrice ? (selectInfo.salePrice / 100).toFixed(2) : '',
            })(
              <InputNumber placeholder="请输入出售价" style={{width: 250}} />
            )}
          </Form.Item>
          <Form.Item label="原价：" className='flex'>
            {getFieldDecorator('costPrice', {
              rules: [{
                required: true,
                message: '请输入原价',
              }],
              initialValue: selectInfo && selectInfo.costPrice ? (selectInfo.costPrice / 100).toFixed(2) : '',
            })(
              <InputNumber placeholder="请输入原价" style={{width: 250}} />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{width: 250, marginLeft: 90}}>保存</Button>
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}